import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from './auth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { router } from './library/router';
import { RouterProvider } from 'react-router-dom';
import { PermissionProvider } from './auth/AuthContext';
import { MockAuthProvider } from './auth/MockAuthProvider';

const queryClient = new QueryClient();

function App() {
  const isTestEnv = process.env.REACT_APP_CI === 'true';
  const Provider = isTestEnv ? MockAuthProvider : AuthProvider;
  const providerProps = isTestEnv ? {} : oidcConfig;

  return <Provider {...providerProps}>
      <QueryClientProvider client={queryClient}>
        <PermissionProvider>
          <RouterProvider router={router}/>
        </PermissionProvider>
      </QueryClientProvider>
    </Provider>;
}

export default App;
